import axios from "axios";
import React from "react";
import { useParams } from "react-router-dom";


function AcceptTask({elem,data,setLoggedInUserData}) {  
  const {id}=useParams();
  const MarkComplete=()=>{
    if(data){
      const newtask=data.tasks.map((updatedTask,index)=>{
        if(updatedTask.title===elem.title){
          return {active:false,category: updatedTask.category,completed:true,date: updatedTask.date,description: updatedTask.description,failed: false,newTask: false,title: updatedTask.title};
        }else{
          return data.tasks[index];
        } 
      })
      let updatedUser={id:data.id,name:data.name,email:data.email,password:data.password,taskCounts:{active:data.taskCounts.active-1,newTask:data.taskCounts.newTask,completed:data.taskCounts.completed+1,failed:data.taskCounts.failed},tasks:newtask}
      setLoggedInUserData(updatedUser)
      axios.put(`https://673cbd3d96b8dcd5f3fb6024.mockapi.io/emts2/${id}`,{
        tasks:newtask,
        taskCounts:{active:data.taskCounts.active-1,newTask:data.taskCounts.newTask,completed:data.taskCounts.completed+1,failed:data.taskCounts.failed}
      });
    }
   
  }


  const MarkFail=()=>{
    if(data){
      const newtask=data.tasks.map((updatedTask,index)=>{
        if(updatedTask.title===elem.title){
          return {active:false,category: updatedTask.category,completed:false,date: updatedTask.date,description: updatedTask.description,failed:true,newTask: false,title: updatedTask.title};
        }else{
          return data.tasks[index];
        }
        
      })
      let updatedUser={id:data.id,name:data.name,email:data.email,password:data.password,taskCounts:{active:data.taskCounts.active-1,newTask:data.taskCounts.newTask,completed:data.taskCounts.completed,failed:data.taskCounts.failed+1},tasks:newtask}
      setLoggedInUserData(updatedUser)
      axios.put(`https://673cbd3d96b8dcd5f3fb6024.mockapi.io/emts2/${id}`,{
        tasks:newtask,
        taskCounts:{active:data.taskCounts.active-1,newTask:data.taskCounts.newTask,completed:data.taskCounts.completed,failed:data.taskCounts.failed+1}
      });
    }
   
    
  }
  return (
    <div className="col-md-6 mb-4">
      <div className="newtask accepted_task">
      <div className="date">
          <span className="high">{elem.category}</span>
          <p>{elem.date}</p>
        </div>
        <h2>{elem.title}</h2>
        <p>
          {elem.description}
        </p>
        <div className="d-flex flex-column gap-2 justify-content-center">
            <button className=" comp-btn" onClick={MarkComplete}>Mark as Completed</button>
            <button className="fail-btn" onClick={MarkFail}>Mark as Failed</button>
        </div>
      </div>
    </div>
  );
}

export default AcceptTask;
